import { RectangleLoader } from "shared";

const Loader = () => {
    return (
        <>
            <RectangleLoader height={68} />

            <RectangleLoader
                height={237}
                customStyle={{
                    marginTop: "16px"
                }}
            />

            <RectangleLoader
                height={20}
                width={156}
                customStyle={{ margin: "16px 0 8px 0" }}
            />
        </>
    );
};

export default Loader;
